import { PropsWithChildren, ReactElement } from 'react'
import * as S from './styled'

export default function ErrorComponent ({ children }: PropsWithChildren): ReactElement {
  return <S.Error>{children}</S.Error>
}
